module.exports = require('./lib/client/index');



//////////////////
// WEBPACK FOOTER
// ./~/feathers-rest/client.js
// module id = 435
// module chunks = 3